interface IWechatConfig {
  debug:boolean; // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  appId:string; // 必填，公众号的唯一标识
  timestamp:number; // 必填，生成签名的时间戳
  nonceStr:string; // 必填，生成签名的随机串
  signature:string; // 必填，签名
  jsApiList:string[]; // 必填，需要使用的JS接口列表
}

export interface IWechatSharedConfig {
  title:string; // 分享标题
  desc:string; // 分享描述
  link:string; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl:string; // 分享图标
}

/**
 * @description 微信分享给朋友配置
 * @author Wynne
 * @date 2021-03-16
 * @param {IWechatSharedConfig} [config]
 */
const wechatAppMessageShared = (config:IWechatSharedConfig) => new Promise((resolve, reject) => {
  window.wx.updateAppMessageShareData({
    title: config.title,
    desc: config.desc,
    link: config.link,
    imgUrl: config.imgUrl,
    success: function() {
      resolve(true);
    },
  });
});

/**
 * @description 微信分享朋友圈配置
 * @author Wynne
 * @date 2021-03-16
 * @param {IWechatSharedConfig} [config]
 */
const wechatTimelineShared = (config:IWechatSharedConfig) => new Promise((resolve, reject) => {
  window.wx.updateTimelineShareData({
    title: config.title,
    desc: config.desc,
    link: config.link,
    imgUrl: config.imgUrl,
    success: function() {
      resolve(true);
    },
  });
});

/**
 * @description 微信初始化
 * @author Wynne
 * @date 2021-03-16
 * @param {IWechatConfig} [config]
 */
export const wechatInit = (config:IWechatConfig) => new Promise((resolve, reject) => {
  window.wx.config(config);
  window.wx.ready(() => {
    resolve(true);
  });
  window.wx.error((res:any) => {
    reject(res);
  });
});

/**
 * @description 微信分享初始化
 * @author Wynne
 * @date 2021-03-16
 * @param {IWechatSharedConfig} [config]
 */
export const wechatSharedInit = async(config:IWechatSharedConfig) => {
  Promise.all([wechatAppMessageShared(config), wechatTimelineShared(config)]).then((res) => {
    console.log(res);
  }).catch((err) => console.log(err));
};
